import type { OpenAPI } from "simplydo/interfaces";

import type { MappedImpactCategory } from "../types";

type ChallengeOwnerImpacts = OpenAPI.Schemas["AssignChallengeOwnerImpacts"];

export const mapOwnerImpacts = ({
  ownerImpacts,
  ownerImpactCategories,
}: ChallengeOwnerImpacts): MappedImpactCategory[] =>
  ([{ name: "Default category", order: -1 }] as MappedImpactCategory[])
    .concat(ownerImpactCategories)
    .map((category) => ({
      ...category,
      impacts: ownerImpacts
        .filter((i) =>
          category._id ? i.category?.id === category._id : !i.category?.id,
        )
        .sort((a, b) => (a.category?.order || 0) - (b.category?.order || 0)),
    }))
    .sort((a, b) => a.order - b.order);
